<div class="synergy-card" *ngIf="offer">

  <mat-card class="item-card offer-card">
    <mat-card-content>

      <!--begin::Content-->
      <div class="wallet_offer_wrapper s_archive_wrapper">
        <div class="offer s_archive row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12 s_archive-img-container">
                <div class="s_archive-img">
                  <img src={{offer.imageURL}} alt={{offer.title}} />
                  <div *ngIf="!hasExpired" class="s_archive-date">
                    {{'GENERAL.TO' | translate}} {{offer.expiresAt | date: 'd.M'}}</div>
                  <div *ngIf="hasExpired" class="s_archive-date">
                    {{'OFFER.STATUS.EXPIRED' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="s_archive-content container-fluid">
              <div class="s_archive-heading row">
                <h4 class="s_archive-title col-9">{{offer.title}}</h4>
                <div *ngIf="offer.cost > 0" class="s_archive-points col-3">
                  <span class="amount">
                    <img src="../../../assets/media/images/Synergy-Icon.png" alt="Synergy" />
                    {{ offer.cost }}
                  </span>
                </div>
              </div>
              <div class="s_archive-subtitle row">
                <div class="col-md-12">
                  <p [innerHTML]="offer.description"></p>
                </div>
              </div>
              <div class="row" *ngIf="type=='all'">
                <div class="col-md-12 s_archive-info">
                  <div class="s_archive-partner">
                    <div class="s_archive-merch-name">
                      <span class="mdi mdi-shopping"></span> {{offer.partner.name}}
                    </div>
                    <div class="s_archive-merch-adress" *ngIf="offer.partner.address">
                      <span class="mdi mdi-pin"></span> {{offer.partner.address.street}}, {{offer.partner.address.city}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content-->

    </mat-card-content>
  </mat-card>
</div>
